import React, { useState } from "react";
import axios from "axios";

function Reader() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const uploadImage = async () => {
    const formData = new FormData();
    (Array.isArray(file) ? file : [file]).forEach(f => formData.append("images", f));

    setLoading(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/upload/multiple`, formData, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "contacts.xlsx");
      link.click();
    } catch (error) {
      alert("Failed to process images.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cover bg-center" 
    style={{ backgroundImage: "url('./assets/img/bg-3.jpg')" }}>
      <div className="flex flex-col items-center">
        <img src="./assets/img/OneHub_Logo1.png" alt="Logo" className="mb-4 w-24 h-24" />

        <h1 className="text-3xl font-bold text-white mb-6 bg-white p-2 rounded shadow-md text-center">
          <span className="text-red-600">One</span>
          <span className="text-yellow-500">Hub</span>
          <span className="text-green-600">India</span>
        </h1>

        <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-md">
          <h3 className="text-xl font-semibold text-center mb-4">📇 WhatsApp Contact Extractor</h3>

          <div className="mb-4">
            <label htmlFor="formFile" className="block text-sm font-medium text-gray-700 mb-1">
              Upload WhatsApp Screenshot(s)
            </label>
            <input
              type="file"
              id="formFile"
              multiple
              onChange={(e) => setFile(Array.from(e.target.files))}
              className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 p-2"
            />
          </div>

          <button
            onClick={uploadImage}
            disabled={!file || loading}
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition duration-200 disabled:opacity-50"
          >
            {loading ? (
              <div className="flex items-center justify-center space-x-2">
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>
                <span>Processing...</span>
              </div>
            ) : (
              "Upload & Extract"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Reader;
